import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Cached } from '@material-ui/icons'
import { makeStyles, Input, Tooltip, styled } from '@material-ui/core'

import UserAvatar from '../shared/UserAvatar'
import StyledSVG from '../shared/StyledSVG'
import { accessSchoolChat } from '../../utils/constants'
import { useHasAccess } from '../../utils/useHasAccess'

import { occupationsObject } from '../../utils/dicts'

import searchIcon from '../../assets/icons/search-icon.svg'

const useStyles = makeStyles(theme => ({
  infiniteScrollWrapper: {
    height: '60vh',
    overflowY: 'auto'
  },
  room_participants_selected: {
    backgroundColor: '#E9FAD9 !important'
  },
  horizontal_bar: {
    width: '100%',
    borderBottom: '1px solid #ADB8CC80',
    margin: '8px 0px'
  },
  room_participants_wrapper: {
    borderRadius: 8
  },
  message_section: {
    cursor: 'pointer',
    display: 'flex',
    gap: 8,
    padding: '8px 8px',
    borderRadius: 8
  },
  message_preview: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto'
  },
  message_preview_info: {
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      color: '#555555',
      fontWeight: 500,
      fontSize: 14,
      margin: 0
    },
    '& span.description': {
      color: '#9F9F9F',
      fontWeight: 400,
      fontSize: 12,
      margin: 0
    }
  },
  chat_name: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  pending_view: {
    width: 16,
    height: 16,
    borderRadius: '100%',
    border: '1px solid #F69E9E',
    color: '#F69E9E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12
  },
  search_component: {
    width: '100%',
    marginTop: '8px',
    marginBottom: '12px',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  useravatar: {
    display: 'block !important',
    width: 'fit-content'
  },
  infiniteScroll: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  endMessageWrapper: {
    textAlign: 'center'
  }
}))

const InputWrapper = styled('div')(({ theme, jstContent }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  alignItems: 'center',
  justifyContent: jstContent
}))

const PrivateRoomMenuMessages = props => {
  const {
    clearPrivateRooms,
    getChats,
    privateRooms,
    roomMenu,
    handleClickRoom,
    currentUser,
    match
  } = props
  const classes = useStyles()
  const [inputValue, setInputValue] = React.useState('')
  const showCachedIcon =
    roomMenu.current_room_type === 1 && roomMenu.current_destination !== 1
  const hasMore =
    privateRooms.pagination.total > privateRooms.items.length &&
    privateRooms.items.length !== 0
  const hasAccess = useHasAccess()

  const truncate = (text, limit) => {
    return text?.length > limit ? `${text.slice(0, limit)}...` : text
  }

  const reloadPrivateRooms = () => {
    clearPrivateRooms()
    getChats({ page: 1 })
  }

  const handleSearchRoom = () => {
    clearPrivateRooms()
    getChats({
      page: 1,
      params: {
        'q[room_participants_user_name_cont]': inputValue
      }
    })
  }

  React.useEffect(() => {
    return () => {
      clearPrivateRooms()
    }
  }, [])

  React.useEffect(
    () => {
      const el = document.getElementById('sidebarScrollable')

      if (!el || privateRooms.isFetching) return

      const isScrollable = el.scrollHeight > el.clientHeight

      if (!isScrollable && hasMore) {
        getChats({
          page: privateRooms?.pagination?.page + 1,
          params: {
            ...(inputValue.length > 0
              ? { 'q[room_participants_user_name_cont]': inputValue }
              : {})
          }
        })
      }
    },
    [
      privateRooms?.items?.length,
      privateRooms?.isFetching,
      privateRooms?.pagination?.page,
      privateRooms?.pagination?.total
    ]
  )

  return (
    <div>
      <InputWrapper jstContent={showCachedIcon ? 'space-between' : 'flex-end'}>
        {showCachedIcon && (
          <Cached
            onClick={reloadPrivateRooms}
            className={classes.reload_rooms}
          />
        )}
        <Input
          disableUnderline
          className={classes.search_component}
          placeholder='Busque pelo nome'
          onChange={event => setInputValue(event.target.value)}
          onKeyDown={event => {
            handleSearchRoom()
          }}
          value={inputValue}
          startAdornment={
            <StyledSVG
              style={{ marginRight: 4 }}
              src={searchIcon}
              width={18}
              height={18}
            />
          }
        />
      </InputWrapper>
      <div id={'sidebarScrollable'} className={classes.infiniteScrollWrapper}>
        <InfiniteScroll
          dataLength={privateRooms?.items?.length}
          scrollableTarget={'sidebarScrollable'}
          scrollThreshold='120px'
          next={() => {
            if (!privateRooms.isFetching) {
              getChats({
                page: privateRooms?.pagination?.page + 1,
                params: {
                  ...(inputValue.length > 0
                    ? {
                        'q[room_participants_user_name_cont]': inputValue
                      }
                    : {})
                }
              })
            }
          }}
          loader={<h4>Carregando...</h4>}
          className={classes.infiniteScroll}
          hasMore={hasMore}
          endMessage={
            !privateRooms.isFetching && !hasMore ? (
              <p className={classes.endMessageWrapper}>
                <b>Todos os contatos carregados.</b>
              </p>
            ) : (
              <p className={classes.endMessageWrapper}>
                <b>Carregando...</b>
              </p>
            )
          }
        >
          {privateRooms?.items?.length > 0 &&
            privateRooms?.items.map((item, index) => {
              const privateRoomWithoutCurrentUser =
                hasAccess(accessSchoolChat) &&
                roomMenu.current_destination === 0
              const tooltipMessage = item?.last_message
                ? `Última mensagem: ${item?.last_message_author} - ${
                    item.last_message.content?.length > 0
                      ? truncate(item.last_message.content, 500)
                      : 'Mensagem sem conteúdo textual'
                  }`
                : ''
              const otherRoomParticipant = item?.room_participants.find(
                item => {
                  return (
                    +item.user.fractal_id !== +currentUser.attributes.fractal_id
                  )
                }
              )
              const roomName = otherRoomParticipant?.user?.name
              let chatContent
              if (privateRoomWithoutCurrentUser) {
                chatContent = (
                  <div>
                    <Tooltip
                      key={`${item.id}${index}`}
                      title={tooltipMessage}
                      leaveDelay={50}
                      placement='right'
                      disableFocusListener
                      disableInteractive
                    >
                      <div
                        onClick={() => handleClickRoom(item.id)}
                        className={`${classes.room_participants_wrapper} ${
                          +match?.params?.chatId === +item.id
                            ? classes.room_participants_selected
                            : ''
                        }`}
                      >
                        <div
                          key={`${item.id} ${Math.random()}`}
                          className={classes.message_section}
                        >
                          <UserAvatar
                            avatarUrl={
                              item.room_participants[0]?.user?.avatar_url
                            }
                            userName={item.room_participants[0]?.user?.name}
                            withoutUserName
                            className={classes.useravatar}
                          />
                          <div className={classes.message_preview}>
                            <div className={classes.message_preview_info}>
                              <div className={classes.chat_name}>
                                <h1>{item.room_participants[0]?.user?.name}</h1>
                                {item?.pending_messages_count > 0 && (
                                  <div className={classes.pending_view}>
                                    {item?.pending_messages_count}
                                  </div>
                                )}
                              </div>
                              <span className='description'>
                                {
                                  occupationsObject[
                                    item.room_participants[0]?.occupation_name
                                  ]
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          key={`${item.id} ${Math.random()}`}
                          className={classes.message_section}
                        >
                          <UserAvatar
                            avatarUrl={
                              item.room_participants[1]?.user?.avatar_url
                            }
                            userName={item.room_participants[1]?.user?.name}
                            withoutUserName
                            className={classes.useravatar}
                          />
                          <div className={classes.message_preview}>
                            <div className={classes.message_preview_info}>
                              <div className={classes.chat_name}>
                                <h1>{item.room_participants[1]?.user?.name}</h1>
                              </div>
                              <span className='description'>
                                {
                                  occupationsObject[
                                    item.room_participants[1]?.occupation_name
                                  ]
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                    <div className={classes.horizontal_bar} />
                  </div>
                )
              } else {
                chatContent = (
                  <div
                    onClick={() => handleClickRoom(item.id)}
                    key={`${item.id} ${Math.random()}`}
                    className={`${classes.message_section} ${
                      +match?.params?.chatId === +item.id
                        ? classes.room_participants_selected
                        : ''
                    }`}
                  >
                    <UserAvatar
                      avatarUrl={otherRoomParticipant?.user?.avatar_url}
                      userName={roomName}
                      withoutUserName
                      className={classes.useravatar}
                    />
                    <div className={classes.message_preview}>
                      <div className={classes.message_preview_info}>
                        <div className={classes.chat_name}>
                          <h1>{roomName}</h1>
                          {item?.pending_messages_count > 0 && (
                            <div className={classes.pending_view}>
                              {item?.pending_messages_count}
                            </div>
                          )}
                        </div>
                        <span className='description'>
                          {
                            occupationsObject[
                              otherRoomParticipant?.occupation_name
                            ]
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                )
              }
              return chatContent
            })}
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default PrivateRoomMenuMessages
